import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { IDocuments } from 'interfaces/documents';

const { Types, Creators } = createActions(
  {
    request: ['id', 'putData', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['errorMessage'],
    reset: [],
  },
  {
    prefix: 'UPDATE_DOCUMENT_',
  }
);

export interface UpdateDocumentState {
  loading: boolean;
  errorMessage: string | null;
}

export interface UpdateDocumentRequestAction {
  id: number;
  putData: IDocuments;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface UpdateDocumentFailureAction {
  errorMessage: string;
  validationErrors?: any;
}

const INITIAL_STATE: UpdateDocumentState = {
  loading: false,
  errorMessage: null,
};

const request = (state: UpdateDocumentState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: UpdateDocumentState) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (
  state: UpdateDocumentState,
  action: UpdateDocumentFailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const reset = () => INITIAL_STATE;

export const updateDocument = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const UpdateDocumentTypes = Types;
export const UpdateDocumentActions = Creators;
